export default __webpack_public_path__ + "static/media/icon 9.43d37454.svg";